<form class="dynamic-form" [formGroup]="form" (submit)="handleSubmit($event)">
  <ng-container *ngFor="let field of config" dynamicField [config]="field" [group]="form"> </ng-container>
</form>
